<!-- src/components/common/Spinner.vue -->
<!--
  Indicateur d'attente, à la place d'`ion-spinner name="crescent"`.

  Les dix-sept appels du projet demandaient tous le même « crescent », c'est à
  dire un arc qui tourne, exactement ce que dessine `LoaderCircle` de Lucide,
  déjà dans le bundle. La taille par défaut reprend les 28px de l'hôte
  `ion-spinner` pour que rien ne bouge dans les mises en page existantes.

  La couleur suit `currentColor`, comme chez Ionic : un appelant qui posait
  `class="text-white"` continue de marcher.
-->
<template>
  <LoaderCircle :size="size" class="animate-spin" role="status" :aria-label="label" />
</template>

<script setup lang="ts">
import { LoaderCircle } from 'lucide-vue-next'

withDefaults(defineProps<{ size?: number; label?: string }>(), {
  size: 28,
  label: undefined,
})
</script>
